import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

import { ColorPalette } from '../../../../design/palette/colorPalette';

export default makeStyles()(({ breakpoints, spacing }: Theme) => ({
  header: {
    backgroundColor: 'white',
    position: 'fixed',
    width: '100%',
    height: '70px',
    top: 0,
    zIndex: 2,
  },
  title: {
    fontSize: 24,
    lineHeight: '36px',
    fontWeight: 700,
    fontFamily: "'Articulat CF', sans-serif",
    color: ColorPalette.BASTILLE,
    textIndent: 20,
  },
  stepTitle: {
    marginBottom: spacing(2),
    fontFamily: "'Articulat CF', sans-serif",
  },
  titleLink: {
    fontSize: 24,
    lineHeight: '36px',
    fontWeight: 700,
    fontFamily: "'Articulat CF', sans-serif",
    color: ColorPalette.BASTILLE,
    textIndent: 20,
    height: 66,
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  closeLink: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  container: {
    maxWidth: '990px',
    marginBottom: 90,
    marginTop: spacing(18),
    [breakpoints.down('md')]: {
      marginTop: spacing(12),
    },
  },
  containerEmbedded: {
    maxWidth: '990px',
    marginBottom: 90,
    marginTop: spacing(3),
    [breakpoints.down('md')]: {
      marginTop: spacing(2),
    },
  },
}));
